import React, { useState, useEffect, useRef } from "react";
import NavigationDrawer from "./../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import TextInput from "../../components/textInput";
import { Box, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { APP_ICONS } from "../../assets";
import SelectInput from "../../components/select";
import DynamicTable from "../../components/dynamicTable";
import { getAllCustomer, userStatusUpdate } from "../../services/customerFn";
import AppLoader from "../../components/loader/loader";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = ["USER NAME", "PHONE", "EMAIL", "STATUS"];

const displayRows = ["user_data", "phone", "email", "profile_status"];

const Customer = () => {
  const [show, setShow] = useState(10);
  const [filterByStatus, setFilterByStatus] = useState("All");
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("userSearchValue") || ""
  );
  const [customerData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const snackRef = useRef(null);

  const handleOpenSnack = (status, message) => {
    if (snackRef.current) {
      snackRef.current.isOpenSnack({
        snackType: status,
        snackMessage: message,
      });
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, []);

  useEffect(() => {
    filterCustomerData();
  }, [searchValue, customerData]);

  const filterCustomerData = () => {
    const filtered = customerData.filter(
      (customer) =>
        customer.fullname?.toLowerCase().includes(searchValue.toLowerCase()) ||
        customer.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
        customer.contact?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    localStorage.setItem("userSearchValue", value);
  };

  const fetchCustomerData = async () => {
    try {
      setLoading(true);
      const response = await getAllCustomer();
      if (response.data.status === "success") {
        const data = response.data.data;
        console.log(data, "data");
        setCustomerData(data);
      } else {
        console.log("error", response.data?.message);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserStatus = async (e, row, index) => {
    console.log(row, "row12313123");

    try {
      setLoading(true);
      const response = await userStatusUpdate(row?._id, {
        status: e,
        type: row?.role,
      });

      if (response.data.status === "success") {
        fetchCustomerData();
        handleOpenSnack("success", "Status updated successfully");
      } else {
        handleOpenSnack("error", response.data?.message);
      }
    } catch (error) {
      console.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <AppLoader isVisible={loading} />
      <CustomBar title={"CUSTOMERS"} />

      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems={"center"}
        >
          <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Customer"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={handleSearchChange}
          />
          {/* <Stack>
            <Typography variant="h5" fontWeight={600}>
              All Users
            </Typography>
            <Typography fontSize={"1.125rem"} color={"customColor.dustyGray"}>
              latest
            </Typography>
          </Stack> */}

          <Stack
            direction={{ sm: "row" }}
            width={"100%"}
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            {/* <SelectInput
              formStyleProps={selectInputWith}
              placeholder={"Show"}
              value={show}
              onChange={(e) => setShow(e.target.value)}
            >
              <MenuItem value={10}>Show 10 </MenuItem>
              <MenuItem value={20}>Show 20 </MenuItem>
              <MenuItem value={30}>Show 30 </MenuItem>
            </SelectInput> */}
            {/* <SelectInput
              placeholder={"Sort by status"}
              formStyleProps={selectInputWith}
              value={filterByStatus}
              onChange={(e) => setFilterByStatus(e.target.value)}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Inactive"}>InActive</MenuItem>
            </SelectInput> */}
            {/* <SelectInput
              formStyleProps={selectInputWith}
              icon={<img src={APP_ICONS.exportGreyIcon} width={16} />}
              placeholder={"Export"}
              value={"Export"}
            >
              <MenuItem value={"Export"}>Export</MenuItem>
            </SelectInput> */}
          </Stack>
        </Stack>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={filteredData}
          handleChangeStatus={handleChangeUserStatus}
          showPagination={true}
          showUserMenu={true}
        />
      </AppContainer>
      <CustomSnackbar ref={snackRef} />
    </NavigationDrawer>
  );
};

export default Customer;
